import { render } from "./ContactTags.vue?vue&type=template&id=7a99e2ca&scoped=true"
import script from "./ContactTags.vue?vue&type=script&lang=js"
export * from "./ContactTags.vue?vue&type=script&lang=js"

import "./ContactTags.vue?vue&type=style&index=0&id=7a99e2ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a99e2ca"]])

export default __exports__